<template>
  <div id="app">
    <nav class="navbar navbar-expand-lg navbar-light bg-light">
      <div class="container">
        <router-link class="navbar-brand" to="/">翎羽集 (Plumefolio)</router-link>
        <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav">
          <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbarNav">
          <ul class="navbar-nav ms-auto">
            <li class="nav-item">
              <router-link class="nav-link" to="/">首页</router-link>
            </li>
            <li class="nav-item">
              <router-link class="nav-link" to="/gallery">图库</router-link>
            </li>
            <li class="nav-item">
              <router-link class="nav-link" to="/upload">上传</router-link>
            </li>
            <li class="nav-item">
              <router-link class="nav-link" to="/about">关于</router-link>
            </li>
            <!-- 用户未登录时显示登录按钮 -->
            <li class="nav-item" v-if="!currentUser">
              <router-link class="nav-link btn btn-outline-primary btn-sm ms-2" to="/auth">登录/注册</router-link>
            </li>
            <!-- 用户已登录时显示用户信息和退出选项 -->
            <li class="nav-item dropdown" v-else>
              <a class="nav-link dropdown-toggle" href="#" id="userDropdown" role="button" data-bs-toggle="dropdown">
                {{ currentUser.username }}
              </a>
              <ul class="dropdown-menu dropdown-menu-end" aria-labelledby="userDropdown">
                <li><a class="dropdown-item" href="#">个人中心</a></li>
                <li><a class="dropdown-item" href="#">我的照片</a></li>
                <li><hr class="dropdown-divider"></li>
                <li><a class="dropdown-item" href="#" @click.prevent="logout">退出登录</a></li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
    </nav>

    <div class="container mt-4">
      <router-view />
    </div>

    <footer class="footer mt-5 py-3 bg-light">
      <div class="container text-center">
        <span class="text-muted">© 2025 翎羽集 (Plumefolio) - 鸟类图片分类系统</span>
      </div>
    </footer>
  </div>
</template>

<script>
import { getCurrentInstance, onMounted, onUnmounted } from 'vue';

export default {
  name: 'App',
  data() {
    return {
      currentUser: null
    };
  },
  setup() {
    const { proxy } = getCurrentInstance();
    
    // 登录事件处理函数
    const handleLogin = (user) => {
      proxy.currentUser = user;
    };
    
    // 登出事件处理函数
    const handleLogout = () => {
      proxy.currentUser = null;
    };
    
    onMounted(() => {
      // 在组件挂载时注册事件监听
      proxy.emitter.on('user-logged-in', handleLogin);
      proxy.emitter.on('user-logged-out', handleLogout);
    });
    
    onUnmounted(() => {
      // 在组件卸载时移除事件监听
      proxy.emitter.off('user-logged-in', handleLogin);
      proxy.emitter.off('user-logged-out', handleLogout);
    });
  },
  created() {
    // 页面加载时从本地存储中获取用户信息
    const userStr = localStorage.getItem('user');
    if (userStr) {
      try {
        this.currentUser = JSON.parse(userStr);
      } catch (e) {
        localStorage.removeItem('user');
      }
    }
  },
  methods: {
    logout() {
      // 清除本地存储中的用户信息
      localStorage.removeItem('user');
      this.currentUser = null;
      
      // 获取事件总线实例
      const { proxy } = getCurrentInstance();
      // 发送登出事件，以便其他组件可以响应
      proxy.emitter.emit('user-logged-out');
      
      // 重定向到首页
      this.$router.push('/');
      
      // 显示退出成功消息
      alert('您已成功退出登录');
    }
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.footer {
  margin-top: auto;
}

.nav-link.btn {
  padding: 0.25rem 0.5rem;
  margin-top: 2px;
}

.dropdown-menu {
  min-width: 10rem;
}
</style> 